import { z } from 'zod';
/** Days without a call before a voice-enabled tenant is flagged at risk. */
export const VOICE_AT_RISK_INACTIVITY_DAYS = 14;
export var VoiceTenantStatusEnum;
(function (VoiceTenantStatusEnum) {
    VoiceTenantStatusEnum["ACTIVE"] = "active";
    VoiceTenantStatusEnum["CANCELLED"] = "cancelled";
})(VoiceTenantStatusEnum || (VoiceTenantStatusEnum = {}));
export var VoiceTenantAtRiskReasonEnum;
(function (VoiceTenantAtRiskReasonEnum) {
    VoiceTenantAtRiskReasonEnum["NO_RECENT_CALLS"] = "no_recent_calls";
    VoiceTenantAtRiskReasonEnum["NO_CALLS_EVER"] = "no_calls_ever";
})(VoiceTenantAtRiskReasonEnum || (VoiceTenantAtRiskReasonEnum = {}));
export const voiceTenantOverviewSchema = z.object({
    tenantId: z.string().uuid(),
    tenantExternalId: z.string().nullable(),
    tenantName: z.string(),
    voiceStatus: z.nativeEnum(VoiceTenantStatusEnum),
    /** ISO-8601; latest agent cancellation, set only when every agent is cancelled. */
    voiceCancelledAt: z.string().nullable(),
    lastCallAt: z.string().nullable(),
    atRisk: z.boolean(),
    atRiskReason: z.nativeEnum(VoiceTenantAtRiskReasonEnum).nullable(),
});
export const voiceTenantOverviewSummarySchema = z.object({
    voiceEnabledTenantCount: z.number(),
    atRiskTenantCount: z.number(),
});
export const voiceUsageStartSchema = z.object({
    /** Earliest agent, including test tenants, matching the Usage aggregates. */
    firstVoiceAgentCreatedAt: z.string().nullable(),
});
export const voiceTenantOverviewListQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().positive().max(100).default(25),
});
export const voiceTenantOverviewListResponseSchema = z.object({
    results: z.array(voiceTenantOverviewSchema),
    pagination: z.object({
        hasNextPage: z.boolean(),
        cursor: z.string().nullable(),
    }),
});
//# sourceMappingURL=voice-tenant-overview.js.map